import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import Home from "@/pages/Home";
import FindMyCar from "@/pages/FindMyCar";
import TrackRequest from "@/pages/TrackRequest";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Policies from "@/pages/Policies";
import usePageTracking from "@/hooks/usePageTracking";

function Tracker() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Tracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/find-my-car" element={<FindMyCar />} />
          <Route path="/track" element={<TrackRequest />} />
          <Route path="/track/:requestId" element={<TrackRequest />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/policies" element={<Policies />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#18181E",
            border: "1px solid rgba(245, 158, 11, 0.3)",
            color: "#F8FAFC",
          },
        }}
      />
    </div>
  );
}

export default App;
